<primecontrol-modal-body>
  <div class="flex flex-row items-center justify-between w-full px-6 gap-3 my-4">
    <primecontrol-input
      class="flex-1"
      [iconPrefix]="'heroicons_solid:search'"
      [control]="searchInputControl"
      [prefix]=""
      [placeholder]="'SEARCH' | translate"
    >
    </primecontrol-input>
  </div>

  <div class="overflow-y-auto flex flex-col flex-1 min-h-0 pb-4 px-4">
    <primecontrol-main-table
      [compactEmpty]="true"
      [columns]="columns()"
      [data]="timeZones()"
      [showSelection]="false"
      [noAction]="true"
      [isLoading]="isLoading()"
      [emptyIcon]="'clock'"
      [emptyMessage]="'NO_TIME_ZONES'"
      [selectedRow]="selectedTimeZone"
      [rowIdKey]="'name'"
      (sort)="onSort($event)"
      (rowClick)="selectTimeZone($event)"
    >
    </primecontrol-main-table>
  </div>
</primecontrol-modal-body>

<primecontrol-modal-footer>
  <div
    class="flex items-center sm:flex-row md:min-h-16 justify-center md:justify-between min-h-30 flex-col-reverse"
  >
    <primecontrol-table-paginator
      [length]="pagination?.totalItems"
      [pageIndex]="pagination.pageIndex"
      class="bg-transparent"
      [pageSize]="pagination?.pageSize"
      (page)="changePage($event)"
      [pageSizeOptions]="[10, 50, 100]"
      [showFirstLastButtons]="true"
      [hidePageSize]="true"
    >
    </primecontrol-table-paginator>

    <div class="flex justify-end w-full md:w-auto gap-3">
      <primecontrol-button
        [label]="'CANCEL'"
        [icon]="'mat_solid:close'"
        [type]="'outline'"
        (event)="close()"
        [color]="'secondary'"
      ></primecontrol-button>

      <primecontrol-button
        [label]="'ACCEPT'"
        [icon]="'heroicons_solid:check'"
        (event)="close(selectedTimeZone)"
        [color]="'primary'"
        [disabled]="!selectedTimeZone"
      ></primecontrol-button>
    </div>
  </div>
</primecontrol-modal-footer>
